import React from 'react'
import { useEffect } from "react";
import { Typography } from '@material-tailwind/react';
import Gallery from '../Components/gallery/Gallery'
import SpecialFooterBar from '../Components/common/SubFooterBar'
import Banner from '../Components/banner/Banner';
import BannerData from '../models/BannersData';
import TitleComponent from '../Components/common/TitleComponent';
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent';

const GalleryPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const BreadCrumbsPath = [
        {
            id: 1,
            pathName: "Gallery",
            pathLink: "/Gallery",
        },
    ];

    return (
        <>

            {BannerData.filter(item => item.title === 'Gallery').map((item) => (
                <Banner key={item.id} bannerDetails={item} />
            ))}

            <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

            <TitleComponent Title={"Gallery"} Subtitle={""} />

            <Gallery />
            <SpecialFooterBar />
        </>
    )
}

export default GalleryPage